import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Input, Row, Select, Typography } from "antd";
import axios from "axios";
import {
  API_BASE_URL,
  directToken,
  DOCTOR_LIST,
  Edit_APPOINTMENT,
  GET_BOOKLIST,
  LIST_OF_AREA,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
import { _put } from "../services/service_api";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
const EditAppoinment = ({ data, disableData }) => {
  const [datesSlots, setDateSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [intervals, setIntervals] = useState([]);
  const [fromTime, setFromTime] = useState([]);
  const [toTime, setToTime] = useState([]);
  const [doctorOption, setDoctorOption] = useState([]);
  const [result, setResult] = useState([]);
  const [chek, setCheck] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState([]);
  const userId = localStorage.getItem("userid");
  const [editing] = useState(true);
  const [formData, setFormData] = useState({
    name: editing ? data.name : "",
    email: editing ? data.email : "",
    phone: editing ? data.phone : "",
    city: editing ? data.city : "",
    area: editing ? data.area : "",
    hospitalName: editing ? data.hospitalId : "",
    doctorName: editing ? data.doctorId : "",
    doctorSpeciality: editing ? data.doctorSpecialityId : "",
    date: editing ? data.date : "",
    time: editing ? data.time : "",
    status: editing ? data.status : "",
    charges: editing ? data.charges : "",
  });

  const [filterCity, setFilterCity] = useState([
    { label: data.cityName, value: data.city },
  ]);
  const [filterAreas, setFilterAreas] = useState([
    { label: data.areaName, value: data.area },
  ]);
  const [filterHospitals, setFilterHospitals] = useState([
    { label: data.hospitalName, value: data.hospitalId },
  ]);
  const [filterSpeciality, setFilterSpeciality] = useState([
    { label: data.specialitiesName, value: data.doctorSpecialityId },
    { label: data.specialitiesName, value: "" },
  ]);
  const [selectedAppointment, setSelectedAppointment] = useState({
    date: editing ? data.date : "",
    time: editing ? data.time : "",
  });

  const [alert, setAlert] = useState(null);
  const [show, setShow] = useState(false);
  const [dayShow, setDayShow] = useState(true);
  const [disabledSlots, setDisabledSlots] = useState([]);
  useEffect(() => {
    if (disableData && Array.isArray(disableData)) {
      const formattedData = disableData.map((item) => ({
        date: item.date,
        time: item.time || "",
        doctorId: item.doctorId || "",
        doctorName: item.doctorName || "",
        doctorSpeciality: item.doctorSpeciality || "",
      }));
      setDisabledSlots(formattedData);
    }
  }, [data]);

  useEffect(() => {
    generateTimeSlots();
    getSpeciality();
    getArea();
    getCity();
    getHospital();
    getDoctor();
  }, [datesSlots, fromTime, toTime, intervals]);

  useEffect(() => {
    setFormData({
      name: data.name,
      email: data.email,
      phone: data.phone,
      city: data.city,
      area: data.area,
      hospitalName: data.hospitalId,
      doctorName: data.doctorId,
      doctorSpeciality: data.doctorSpecialityId,
      date: data.date,
      time: data.time,
      status: data.status,
      charges: data.charges,
    });
    if (formData.doctorName) {
      fetchSlotsList(formData.doctorName);
    }
  }, [formData.doctorName, data]);
  const fetchSlotsList = async (doctorId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${GET_BOOKLIST}${doctorId}`
      );
      if (response.data) {
        setResult(response.data);
        const slotsData = response.data;
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const filteredSlotsData = slotsData.filter((slot) => {
          const slotDate = new Date(slot.date);
          slotDate.setHours(0, 0, 0, 0);
          return slotDate >= currentDate;
        });
        setDateSlots(filteredSlotsData.map((slot) => slot.date));
        setIntervals(filteredSlotsData.map((slot) => slot.interval));
        setFromTime(filteredSlotsData.map((slot) => slot.fromTime));
        setToTime(filteredSlotsData.map((slot) => slot.toTime));
      } else {
        console.error("Error fetching the data");
      }
    } catch (error) {
      console.error("Error fetching the data:", error);
    }
  };

  const generateTimeSlots = () => {
    if (
      !fromTime.length ||
      !toTime.length ||
      !intervals.length ||
      !datesSlots.length
    ) {
      console.error(
        "fromTime, toTime, intervals, or datesSlots array is empty"
      );
      return;
    }
    const slots = [];
    const convertToMinutes = (time) => {
      const [timePart, period] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);
      if (period === "PM" && hours !== 12) {
        hours += 12;
      }
      if (period === "AM" && hours === 12) {
        hours = 0;
      }

      return hours * 60 + minutes;
    };

    datesSlots.forEach((date, index) => {
      const start = fromTime[index];
      const end = toTime[index];
      const range = intervals[index];

      const startTime = convertToMinutes(start);
      const endTime = convertToMinutes(end);

      if (isNaN(startTime) || isNaN(endTime)) {
        console.error(`Error parsing start or end times for date ${date}`);
        return;
      }

      for (let i = startTime; i < endTime; i += parseInt(range)) {
        let hours = Math.floor(i / 60);
        let minutes = i % 60;
        let formattedStartTime = `${hours % 12 || 12}:${
          minutes < 10 ? "0" : ""
        }${minutes} ${hours >= 12 ? "PM" : "AM"}`;

        let nextTime = i + parseInt(range);
        hours = Math.floor(nextTime / 60);
        minutes = nextTime % 60;
        let formattedEndTime = `${hours % 12 || 12}:${
          minutes < 10 ? "0" : ""
        }${minutes} ${hours >= 12 ? "PM" : "AM"}`;

        slots.push({
          date: date,
          start: formattedStartTime,
          end: formattedEndTime,
        });
      }
    });

    setTimeSlots(slots);
  };

  const fridayTimeSlots = timeSlots.filter((slot) => slot.date === chek);
  const splitIntoRows = (slots, slotsPerRow) => {
    const rows = [];
    for (let i = 0; i < slots.length; i += slotsPerRow) {
      rows.push(slots.slice(i, i + slotsPerRow));
    }
    return rows;
  };
  const [currentDatePage, setCurrentDatePage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const slotsPerRow = 4;
  const rowsPerPage = 4;
  const datesPerRow = 4;
  const rowsPerDatePage = 1;
  const dateRows = splitIntoRows(datesSlots, datesPerRow);
  const totalDatePages = Math.ceil(dateRows.length / rowsPerDatePage);
  const currentDates = dateRows.slice(
    currentDatePage * rowsPerDatePage,
    (currentDatePage + 1) * rowsPerDatePage
  );

  const handleNextDatePage = () => {
    if (currentDatePage < totalDatePages - 1) {
      setCurrentDatePage(currentDatePage + 1);
    }
  };

  const handlePreviousDatePage = () => {
    if (currentDatePage > 0) {
      setCurrentDatePage(currentDatePage - 1);
    }
  };
  const rows = splitIntoRows(fridayTimeSlots, slotsPerRow);
  const totalPages = Math.ceil(rows.length / rowsPerPage);
  const currentRows = rows.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );
  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const getDoctor = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };
      const response = await fetch(`${API_BASE_URL}${DOCTOR_LIST}${userId}`, {
        headers,
      });
      const data = await response.json();
      setDoctorOption(
        data.list.map((source) => ({
          label: source.doctorsName,
          value: source.id,
        }))
      );
      setSelectedDoctor(data.list);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setSelectedCity(data.list);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const getArea = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_AREA}`, {
        headers,
      });
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      setSelectedArea(data.list);
    } catch (error) {
      console.error("Error fetching areas:", error);
    }
  };

  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setSelectedHospital(data.list);
    } catch (error) {
      console.error("Error fetching hospitals:", error);
    }
  };
  const getSpeciality = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`,
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`,
        { headers }
      );
      const data = await response.json();
      setSelectedSpeciality(data.list);
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  const handleDoctorChange = (value) => {
    handleInputValues("doctorName", value);

    const filteredValue = selectedDoctor.find((doctor) => doctor.id === value);

    if (filteredValue) {
      const {
        cityName,
        areaName,
        hospitalName,
        speciality,
        cityId,
        areaId,
        hospitalId,
        specialityId,
      } = filteredValue;

      handleInputValues("city", cityId);
      handleInputValues("area", areaId);
      handleInputValues("hospitalName", hospitalId);
      //   handleInputValues("doctorSpeciality", doctorSpecialityId);

      setFilterCity([{ label: cityName, value: cityId }]);
      setFilterAreas([{ label: areaName, value: areaId }]);
      setFilterHospitals([{ label: hospitalName, value: hospitalId }]);
      setFilterSpeciality([{ label: speciality, value: specialityId }]);

      fetchSlotsList(value);
    }
  };
  const handleDateChange = (date) => {
    setCheck(date);
    setFormData((prevData) => ({
      ...prevData,
      date: date,
    }));
    setSelectedAppointment((prevData) => ({
      ...prevData,
      date: date,
    }));
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    setFormData((prevData) => ({
      ...prevData,
      time: time.start,
    }));
    setSelectedAppointment((prevData) => ({
      ...prevData,
      time: time.start,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = data.appointmentId;

    try {
      const result = await _put(
        `${API_BASE_URL}${Edit_APPOINTMENT}${id}`,
        formData,
        directToken
      );
      window.location.reload();
      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        area: "",
        hospitalName: "",
        doctorName: "",
        doctorSpeciality: "",
        date: "",
        time: "",
        status: "",
        charges: "",
      });
      setShow(false);
      setDayShow(false);
      if (result.status === 200) {
        setAlert(true);
      }
    } catch (err) {
      if (err.response) {
        console.error("Server responded with status:", err.response.status);
        console.error("Response data:", err.response.data);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        // console.error("Error setting up request:", err.message);
      }

      setAlert(false);
    }
  };

  const handleChanges = () => {
    setShow((prev) => !prev);
  };

  const handleInputValues = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      city: "",
      area: "",
      hospitalName: "",
      doctorName: "",
      doctorSpeciality: "",
      date: "",
      time: "",
      status: "",
      charges: "",
    });
  };
  const status = ["Visited", "Rescheduled", "Cancelled"];
  const isSlotDisabled = (slot) => {
    return disabledSlots.some(
      (disabledSlot) =>
        disabledSlot.date === slot.date &&
        disabledSlot.time === slot.start &&
        disabledSlot.doctorId === formData.doctorName &&
        disabledSlot.specialityId === formData.specialityId
    );
  };

  return (
    <>
      <Form layout="vertical">
        <div style={{ marginTop: "20px" }}>
          {alert && (
            <div marginBottom="20px">
              <Alert
                style={{
                  backgroundColor:
                    // alert.type === "success" ? "#009f70e6" : "#f44336",
                    "#dff0d8",
                  color: "green",
                  fontSize: "16px",
                  borderColor: "#dff0d8",
                  textAlign: "center",
                }}
                message={"Appointment Updated!"}
              />
            </div>
          )}
        </div>
        <Row style={{ gap: "10px" }}>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Name" required>
              <Input
                style={{ height: "40px" }}
                id="Name"
                name="name"
                value={formData.name}
                onChange={(e) => handleInputValues("name", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Email" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Email"
                value={formData.email}
                name="email"
                onChange={(e) => handleInputValues("email", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xl={7} lg={7} md={11} sm={24} xs={24}>
            <Form.Item label="Phone" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Phone"
                name="phone"
                value={formData.phone}
                onChange={(e) => handleInputValues("phone", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Select Doctor" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="doctorName"
                value={formData.doctorName || undefined}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownStyle={{ maxHeight: "100%", overflowY: "auto" }}
                onChange={(value) => {
                  handleInputValues("doctorName", value);
                  const filteredValue = selectedDoctor.find(
                    (doctor) => doctor.id === value
                  );
                  if (filteredValue) {
                    const {
                      cityName,
                      areaName,
                      hospitalName,
                      specialityName,
                      cityId,
                      areaId,
                      hospitalId,
                      specialityId,
                    } = filteredValue;
                    handleInputValues("city", cityId);
                    handleInputValues("area", areaId);
                    handleInputValues("hospitalName", hospitalId);
                    handleInputValues("doctorSpeciality", specialityId);
                    setFilterCity([{ label: cityName, value: cityId }]);
                    setFilterAreas([{ label: areaName, value: areaId }]);
                    setFilterHospitals([
                      { label: hospitalName, value: hospitalId },
                    ]);
                    setFilterSpeciality([
                      { label: specialityName, value: specialityId },
                    ]);
                    fetchSlotsList(value);
                  }
                }}
                options={doctorOption}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Select City" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="city"
                value={formData.city || undefined}
                onChange={(value) => {
                  handleInputValues("city", value);
                }}
                options={filterCity}
              />
            </Form.Item>
          </Col>
          <Col xl={7} lg={7} md={11} sm={24} xs={24}>
            <Form.Item label="Select Area" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="area"
                value={formData.area || undefined}
                onChange={(value) => {
                  handleInputValues("area", value);
                }}
                options={filterAreas}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Select Hospital" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="hospitalName"
                value={formData.hospitalName || undefined}
                onChange={(value) => {
                  handleInputValues("hospitalName", value);
                }}
                options={filterHospitals}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={24} xs={24}>
            <Form.Item label="Select Speciality" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="doctorSpeciality"
                value={formData.doctorSpeciality || undefined}
                onChange={(value) => {
                  handleInputValues("doctorSpeciality", value);
                }}
                options={filterSpeciality}
              />
            </Form.Item>
          </Col>
          <Col xl={7} lg={8} md={11} sm={20} xs={24}>
            <Form.Item label="Select Status" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="status"
                placeholder="Status"
                value={formData.status || undefined}
                onChange={(value) => handleInputValues("status", value)}
                options={status.map((s) => ({ value: s, label: s }))}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={11} sm={20} xs={24}>
            {/* {formData.status === "Visited" && (
              <div>
                <Form.Item label="Select Speciality">
                  <Input
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    placeholder="Charges"
                    value={formData.charges}
                    onChange={(e) =>
                      handleInputValues("charges", e.target.value)
                    }
                  />
                </Form.Item>
              </div>
            )} */}
          </Col>
        </Row>
        <hr style={{ marginTop: "20px", borderTop: "1px solid #ccc" }} />{" "}
        <div>
          {dayShow ? (
            datesSlots.length > 0 ? (
              <div style={{ marginRight: "16px" }}>
                <Typography.Text>Schedule Dates</Typography.Text>
                {currentDates.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Left Arrow Button */}
                      <Button
                        onClick={handlePreviousDatePage}
                        disabled={currentDatePage === 0}
                        icon={<LeftOutlined />}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: 1,
                          justifyContent: "center",
                        }}
                      >
                        {currentDates.map((row, rowIndex) => (
                          <div
                            key={rowIndex}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            {row.map((date, index) => (
                              <Button
                                size="small"
                                key={index}
                                onClick={() => {
                                  handleChanges();
                                  handleDateChange(date);
                                }}
                                style={{
                                  marginTop: "15px",

                                  margin: "5px",
                                  height: "60px",
                                  width: "100%",
                                  maxWidth: "120px",
                                  fontSize: "14px",
                                  border: "1px solid #0899f9",
                                  borderRadius: "11px",
                                  backgroundColor:
                                    selectedAppointment.date === date
                                      ? "#0899f9"
                                      : "#ffffff",
                                  color:
                                    selectedAppointment.date === date
                                      ? "#ffffff"
                                      : "#0899f9",
                                }}
                              >
                                {date}
                              </Button>
                            ))}
                          </div>
                        ))}
                      </div>

                      {/* Right Arrow Button */}
                      <Button
                        onClick={handleNextDatePage}
                        disabled={currentDatePage === totalDatePages - 1}
                        icon={<RightOutlined />}
                      />
                    </div>
                  </div>
                ) : (
                  <Typography.Text>No available dates</Typography.Text>
                )}
              </div>
            ) : (
              <Typography.Text>No available slots</Typography.Text>
            )
          ) : (
            <Typography.Text>
              Select a day to see available slots
            </Typography.Text>
          )}

          {/* Time Slot Section */}
          {show && (
            <div>
              <Typography.Text>Time Slots</Typography.Text>
              {currentRows.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Left Arrow Button for Time Slots */}
                    <Button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 0}
                      icon={<LeftOutlined />}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        justifyContent: "center",
                      }}
                    >
                      {currentRows.map((row, rowIndex) => (
                        <div
                          key={rowIndex}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          {row.map((slot, index) => (
                            <Button
                              size="small"
                              key={index}
                              disabled={isSlotDisabled(slot)}
                              onClick={() => handleTimeChange(slot)}
                              style={{
                                border: "1px solid #0899f9",
                                borderRadius: "11px",
                                height: "30px",
                                margin: "5px",
                                background: isSlotDisabled(slot)
                                  ? "#f0f0f0"
                                  : selectedAppointment &&
                                    selectedAppointment.time === slot.start
                                  ? "#1677ffd1"
                                  : "#ffffff",
                                color:
                                  selectedAppointment &&
                                  selectedAppointment.time === slot.start
                                    ? "#ffffff"
                                    : "#0899f9",
                                fontSize: "13px",
                                width: "130px",
                              }}
                            >
                              {`${slot.start} - ${slot.end}`}
                            </Button>
                          ))}
                        </div>
                      ))}
                    </div>
                    <Button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages - 1}
                      icon={<RightOutlined />}
                    />
                  </div>
                </div>
              ) : (
                <Typography.Text>No available time slots</Typography.Text>
              )}
            </div>
          )}
        </div>
        <Row gutter={[12, 12]} style={{ justifyContent: "space-between" }}>
          <Col
            xl={6}
            md={6}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Button
              type="button"
              onClick={handleReset}
              style={{
                color: "black",
                border: "solid #1236fa",
                width: "100px",
                height: "30px",
                borderRadius: "3vw",
              }}
            >
              Reset
            </Button>
          </Col>
          <Col
            xl={6}
            md={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              type="submit"
              onClick={handleSubmit}
              style={{
                color: "white",
                background: "#1236fa",
                width: "100px",
                height: "30px",
                borderRadius: "3vw",
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default EditAppoinment;
